var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.7735C11.96 4.76683 11.9133 4.76683 11.8733 4.7735C10.9533 4.74017 10.22 3.98683 10.22 3.0535C10.22 2.10016 10.9866 1.3335 11.94 1.3335C12.8933 1.3335 13.66 2.10683 13.66 3.0535C13.6533 3.98683 12.92 4.74017 12 4.7735Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3132 9.62694C12.2265 9.78027 13.2332 9.62027 13.9399 9.14694C14.8799 8.52027 14.8799 7.4936 13.9399 6.86694C13.2265 6.3936 12.2065 6.2336 11.2932 6.3936",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98007 4.7735C4.02007 4.76683 4.06674 4.76683 4.10674 4.7735C5.02674 4.74017 5.76007 3.98683 5.76007 3.0535C5.76007 2.10016 4.9934 1.3335 4.04007 1.3335C3.08674 1.3335 2.32007 2.10683 2.32007 3.0535C2.32674 3.98683 3.06007 4.74017 3.98007 4.7735Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 9.62694C3.75329 9.78027 2.74663 9.62027 2.03996 9.14694C1.09996 8.52027 1.09996 7.4936 2.03996 6.86694C2.75329 6.3936 3.77329 6.2336 4.68663 6.3936",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 9.75348C7.95997 9.74681 7.9133 9.74681 7.8733 9.75348C6.9533 9.72015 6.21997 8.96681 6.21997 8.03348C6.21997 7.08014 6.98664 6.31348 7.93997 6.31348C8.8933 6.31348 9.65997 7.08681 9.65997 8.03348C9.6533 8.96681 8.91997 9.72681 7.99997 9.75348Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05998 11.8532C5.11998 12.4799 5.11998 13.5066 6.05998 14.1332C7.12665 14.8466 8.87331 14.8466 9.93998 14.1332C10.88 13.5066 10.88 12.4799 9.93998 11.8532C8.87998 11.1466 7.12665 11.1466 6.05998 11.8532Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPeople;